import { render, staticRenderFns } from "./TableSeplag.vue?vue&type=template&id=4067d1be&"
import script from "./TableSeplag.vue?vue&type=script&lang=js&"
export * from "./TableSeplag.vue?vue&type=script&lang=js&"
import style0 from "./TableSeplag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports